class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure_element'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    // Show-all-countries toggle
    this.querySelectorAll('[data-show-all-countries]').forEach(btn => {
      btn.addEventListener('click', this.showAllCountries.bind(this));
    });
  }

  showAllCountries(event) {
    this.querySelector('.disclosure__list--all').removeAttribute('hidden');
    event.currentTarget.closest('li').remove();
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    if (!form) return;

    const value = event.currentTarget.dataset.value;
    this.elements.input.value = value;

    if (window.fndTrack) {
      fndTrack('Localization Changed', {
        field: this.elements.input.name === 'country_code' ? 'country' : 'language',
        value: value
      });
    }

    this.hidePanel();
    this.submitAndReload(form);
  }

  async submitAndReload(form) {
    this.setAttribute('aria-busy', 'true');
    document.body.classList.add('localization-changing');

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' },
      });

      if (response.redirected && response.url !== window.location.href) {
        window.location.href = response.url;
      } else {
        window.location.reload();
      }
    } catch (error) {
      // Network hiccup or fetch blocked — fall back to a normal submit
      form.submit();
    }
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    if (event.target.classList.contains('country-selector__overlay') || !this.contains(event.target) || !this.contains(event.relatedTarget)) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);